module.exports = __webpack_public_path__ + "static/media/card2_5.397d55e6.png";